module.exports = __webpack_public_path__ + "static/img/logo-pia-mobil.bdb4db64.svg";